import { useState, useEffect } from 'react';


interface SectionContent {
    title: string;
    subtitle: string;
    description: string;
    image?: string;
    buttonText?: string;
    buttonLink?: string;
    [key: string]: any;
}

interface PageContent {
    [sectionId: string]: SectionContent;
}

export const usePageContent = (pageId: string, language: string = 'en') => {
    const [content, setContent] = useState<PageContent | null>(null);
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        const fetchContent = async () => {
            try {
                setLoading(true);
                const response = await fetch(`/api/cms/${pageId}?language=${language}`);
                const data = await response.json();
                if (data && data.success && data.content) {
                    // Backend returns { content: { sectionId: contentObj, ... } }
                    setContent(data.content);
                } else {
                    // No content found, set empty content
                    setContent({});
                }
            } catch (err) {
                console.error(`Error fetching content for ${pageId}:`, err);
                setError('Failed to load content');
            } finally {
                setLoading(false);
            }
        };

        if (pageId) {
            fetchContent();
        }
    }, [pageId, language]);

    return { content, loading, error };
};
